import { render } from "./people-list.vue?vue&type=template&id=02b2a5b2&scoped=true&ts=true"
import script from "./people-list.vue?vue&type=script&lang=ts"
export * from "./people-list.vue?vue&type=script&lang=ts"

import "./people-list.vue?vue&type=style&index=0&id=02b2a5b2&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b2a5b2"]])

export default __exports__